import { render, staticRenderFns } from "./billing_address.vue?vue&type=template&id=2147d796&"
import script from "./billing_address.vue?vue&type=script&lang=js&"
export * from "./billing_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports